module.exports = __webpack_public_path__ + "img/timbuktoo@300x.dae99be0.png";